import _extends from "@babel/runtime/helpers/extends";
/** @jsx jsx */
import { jsx } from '@emotion/react';
import LozengeActionItem from '../lozenge-action-item';
import { dropdownItemGroupStyles } from '../styled';
import { DropdownItemGroup } from '@atlaskit/dropdown-menu';
const LozengeActionItemsGroup = ({
  items,
  testId,
  onClick
}) =>
// eslint-disable-next-line @atlaskit/design-system/prefer-primitives
jsx("span", {
  css: dropdownItemGroupStyles,
  "data-testid": `${testId}-item-group`
}, jsx(DropdownItemGroup, null, items.map((item, idx) => jsx(LozengeActionItem, _extends({}, item, {
  key: idx,
  onClick: onClick,
  testId: `${testId}-item-${idx}`
})))));
export default LozengeActionItemsGroup;